import { useParams } from "react-router-dom";
import { fill, useLayout, useTexts } from "@/lib/layout";
import { Seo, breadcrumbLd } from "@/components/site/Seo";
import { StoryFeed, useArticleFeed } from "@/components/site/StoryFeed";
import NotFound from "@/pages/NotFound";

export default function Category() {
  const { slug } = useParams();
  const { data: layout } = useLayout();
  const feed = useArticleFeed("category", { category: slug });
  const t = useTexts("category");
  const cat = layout?.categories.find((c) => c.slug === slug);
  const vars = { seccion: cat?.name || "", descripcion: cat?.description || "" };
  if (layout && !cat) return <NotFound />;
  const total = feed.data?.pages[0]?.total;
  return (
    <div className="wrap pt-10 md:pt-14" data-testid="category-page">
      {cat && (
        <Seo
          title={cat.seo_title || fill(t.seo_title_template, vars)}
          description={cat.seo_description || fill(t.seo_description_template, vars).trim()}
          noindex={cat.noindex}
          jsonLd={[
            { "@context": "https://schema.org", "@type": "CollectionPage", name: `${cat.name} · El Noticiero`, description: cat.description, inLanguage: "es-ES" },
            breadcrumbLd([{ name: "Portada", path: "/" }, { name: cat.name, path: `/seccion/${cat.slug}` }]),
          ]}
        />
      )}
      <header className="grid md:grid-cols-12 gap-6 items-end border-b-2 border-foreground pb-8 mb-12">
        <div className="md:col-span-8">
          <p className="kicker text-primary">{t.kicker}</p>
          <h1 className="font-display font-black tracking-[-0.03em] text-5xl sm:text-6xl mt-2" data-testid="category-title">{cat?.name || "…"}</h1>
        </div>
        <div className="md:col-span-4 md:text-right">
          <p className="text-muted-foreground leading-relaxed">{cat?.description}</p>
          {total !== undefined && <p className="kicker mt-3 text-muted-foreground" data-testid="category-count">{total} {total === 1 ? t.count_one : t.count_many}</p>}
        </div>
      </header>
      <StoryFeed feed={feed} empty={t.empty} />
    </div>
  );
}
